module.exports = __webpack_public_path__ + "static/media/ch.f0617e6d.svg";